import { currentUser } from './user'
import type { PublicUser } from '../types'

/** 'me' is the logged user. Every author id in the social data resolves here. */
export const people: PublicUser[] = [
  {
    id: 'me',
    name: currentUser.name,
    username: currentUser.username,
    avatar: currentUser.avatar,
    bio: {
      'pt-BR': 'Corrida e musculação. Construindo consistência um dia por vez.',
      'en-US': 'Running and strength. Building consistency one day at a time.',
    },
    category: 'running',
    streak: currentUser.streak,
    counts: { posts: 34, followers: 428, following: 216 },
    badges: ['badge.first', 'badge.focus', 'badge.week'],
    publicMetrics: [
      { label: { 'pt-BR': 'PR 10 km', 'en-US': '10 km PR' }, value: '48:12' },
      { label: { 'pt-BR': 'Pace médio', 'en-US': 'Avg pace' }, value: '5:32/km' },
      { label: { 'pt-BR': 'Treinos/semana', 'en-US': 'Workouts/week' }, value: '4' },
    ],
    following: false,
  },
  {
    id: 'lucas',
    name: 'Lucas Ferreira',
    username: '@lucas.corre',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/733cd030-14e5-4aed-964e-5d32831fb013.jpg',
    bio: {
      'pt-BR': 'Maratonista amador. Treino cedo, durmo cedo.',
      'en-US': 'Amateur marathoner. Early training, early nights.',
    },
    category: 'running',
    streak: 18,
    counts: { posts: 112, followers: 2140, following: 308 },
    badges: ['badge.week', 'badge.unstoppable'],
    publicMetrics: [
      { label: { 'pt-BR': 'PR 21 km', 'en-US': '21 km PR' }, value: '1:34:08' },
      { label: { 'pt-BR': 'Maior distância', 'en-US': 'Longest run' }, value: '32 km' },
      { label: { 'pt-BR': 'Pace médio', 'en-US': 'Avg pace' }, value: '4:28/km' },
    ],
    following: true,
  },
  {
    id: 'marina',
    name: 'Marina Duarte',
    username: '@marina.duarte',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/e306f03a-f625-493a-ad07-7c60e9c4bf38.jpg',
    bio: {
      'pt-BR': 'Respiração, sono e rotina. Saúde mental em primeiro lugar.',
      'en-US': 'Breathing, sleep and routine. Mental health first.',
    },
    category: 'mindfulness',
    streak: 7,
    counts: { posts: 76, followers: 1580, following: 194 },
    badges: ['badge.first', 'badge.focus', 'badge.week'],
    publicMetrics: [
      { label: { 'pt-BR': 'Minutos de mente', 'en-US': 'Mind minutes' }, value: '280/mês' },
      { label: { 'pt-BR': 'Sono médio', 'en-US': 'Avg sleep' }, value: '7h40' },
    ],
    following: false,
  },
  {
    id: 'rafael',
    name: 'Rafael Tanaka',
    username: '@rafa.tanaka',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/a886c022-afde-4ed2-bb00-3bee610d9f54.jpg',
    bio: {
      'pt-BR': 'Musculação e progressão de carga. Paciência é método.',
      'en-US': 'Strength and load progression. Patience is method.',
    },
    category: 'strength',
    streak: 31,
    counts: { posts: 58, followers: 964, following: 121 },
    badges: ['badge.week', 'badge.unstoppable', 'badge.legend'],
    publicMetrics: [
      { label: { 'pt-BR': 'Agachamento 1RM', 'en-US': 'Squat 1RM' }, value: '120 kg' },
      { label: { 'pt-BR': 'Supino 1RM', 'en-US': 'Bench 1RM' }, value: '92 kg' },
      { label: { 'pt-BR': 'Treinos/semana', 'en-US': 'Workouts/week' }, value: '5' },
    ],
    following: true,
  },
  {
    id: 'juliana',
    name: 'Juliana Alves',
    username: '@ju.alves',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/ab14661c-3a50-4769-b35a-456f8f27d408.jpg',
    bio: {
      'pt-BR': 'Natação e triatlo. Água antes do café.',
      'en-US': 'Swimming and triathlon. Water before coffee.',
    },
    category: 'swimming',
    streak: 9,
    counts: { posts: 41, followers: 712, following: 145 },
    badges: ['badge.first', 'badge.week'],
    publicMetrics: [
      { label: { 'pt-BR': 'Pace 100 m', 'en-US': '100 m pace' }, value: '1:42' },
      { label: { 'pt-BR': 'Volume semanal', 'en-US': 'Weekly volume' }, value: '9,2 km' },
    ],
    following: false,
  },
  {
    id: 'pedro',
    name: 'Pedro Nunes',
    username: '@pedro.nunes',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/cb5be505-936e-4565-b2b9-8835d3a70de6.jpg',
    bio: {
      'pt-BR': 'Ciclismo de estrada. Subida é onde a cabeça treina.',
      'en-US': 'Road cycling. Climbs are where the mind trains.',
    },
    category: 'cycling',
    streak: 14,
    counts: { posts: 88, followers: 1320, following: 260 },
    badges: ['badge.week', 'badge.unstoppable'],
    publicMetrics: [
      { label: { 'pt-BR': 'FTP', 'en-US': 'FTP' }, value: '268 W' },
      { label: { 'pt-BR': 'W/kg', 'en-US': 'W/kg' }, value: '3,8' },
    ],
    following: false,
  },
  {
    id: 'camila',
    name: 'Camila Rocha',
    username: '@camila.rocha',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/7136f952-7fc0-498d-9c69-11dffd72e5a9.jpg',
    bio: {
      'pt-BR': 'CrossFit e mobilidade. Técnica antes de carga.',
      'en-US': 'CrossFit and mobility. Technique before load.',
    },
    category: 'crossfit',
    streak: 22,
    counts: { posts: 63, followers: 1105, following: 178 },
    badges: ['badge.focus', 'badge.week', 'badge.unstoppable'],
    publicMetrics: [
      { label: { 'pt-BR': 'VO2 máx', 'en-US': 'VO2 max' }, value: '46' },
      { label: { 'pt-BR': 'Clean 1RM', 'en-US': 'Clean 1RM' }, value: '68 kg' },
    ],
    following: false,
  },
]

export function findPerson(id: string): PublicUser {
  return people.find((person) => person.id === id) ?? people[0]
}

export function findByUsername(username: string): PublicUser | undefined {
  const normalized = username.startsWith('@') ? username : `@${username}`
  return people.find((person) => person.username === normalized)
}
